window.newRelicLogger = {
    logAction: (pageAction, info)->
      if window.newrelic
        window.newrelic.addPageAction(pageAction, info)

    logSseEvent: (event)->
      try
        info = {
          event_type: event.event_type,
          account_id: event.account_id,
          user: Keepcon.currentUser
        }
        @logAction('Sse/Event', info)
      catch error
#      Nothing to do here

    logSseConnectedEvent: ()->
      try
        info = {
          channel_id: Keepcon.eventSourceChannelId,
          user: Keepcon.currentUser
        }
        @logAction('Sse/Success/ConnectEvents', info)
      catch error
#      Nothing to do here

    logSseDisconnectedEvent: (event)->
      try
        info = {
          target: event.target,
          type: event.type,
          user: Keepcon.currentUser
        }
        @logAction('Sse/Error/DisconectEvents', info)
      catch error
#      Nothing to do here
  }

